var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArticleComments = function SvgArticleComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.913.658C5.988.388 8.103.25 10.25.25c2.147 0 4.262.139 6.337.408 1.922.25 3.291 1.861 3.405 3.727a4.403 4.403 0 0 0-1.032-.211 50.89 50.89 0 0 0-8.42 0C8.182 4.37 6.5 6.364 6.5 8.608v4.286a4.47 4.47 0 0 0 2.433 3.984L6.28 19.53A.75.75 0 0 1 5 19v-4.03a48.527 48.527 0 0 1-1.087-.128C1.905 14.58.5 12.833.5 10.862V4.638C.5 2.667 1.905.92 3.913.658Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.75 5.5c-1.376 0-2.739.057-4.086.169C9.124 5.797 8 7.103 8 8.609v4.285c0 1.507 1.128 2.814 2.67 2.94 1.243.102 2.5.157 3.768.165l2.782 2.781a.75.75 0 0 0 1.28-.53v-2.39l.33-.026c1.542-.125 2.67-1.432 2.67-2.94V8.608c0-1.505-1.125-2.811-2.664-2.94A49.392 49.392 0 0 0 14.75 5.5Z"
  })));
};
export default SvgArticleComments;